import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-material-design-icons',
	templateUrl:'./MaterialDesignIconsPluginPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_621 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>material-design-icons</artifactId>
</dependency>
\`\`\``;
	mdContent_622 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:material-design-icons")
\`\`\``;
	mdContent_623 = `\`\`\`java
var icon = new MaterialDesignIcon<>(MaterialDesignIcons.home);
var outlined = new MaterialDesignIcon<>(
    MaterialDesignIconThemes.Outlined,
    MaterialDesignIcons.settings);
\`\`\``;
	mdContent_624 = `\`\`\`java
// Default filled icon at 24px
var icon = new MaterialDesignIcon<>(MaterialDesignIcons.home);

// Outlined theme, 48px, dark colour
var big = new MaterialDesignIcon<>(
    MaterialDesignIconThemes.Outlined,
    MaterialDesignIcons.settings,
    MaterialDesignIconSize.$48,
    MaterialDesignIconColours.Dark);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
